import React from 'react';
import PropTypes from 'prop-types';
import { getSupValue, removeSup } from 'helpers/superscript';

const Sup = ({ children }) => {
  const str = String(children);
  return String(str).includes('&sup') ? (
    <span>
      {removeSup(str)}
      <sup>{getSupValue(str)}</sup>
    </span>
  ) : children ? (
    children
  ) : null;
};

Sup.propTypes = {
  children: PropTypes.node,
};

export default Sup;



// WEBPACK FOOTER //
// ./src/components/Sup/Sup.jsx